var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background" },
    [
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", color: "#f00" } },
            [_vm._v(_vm._s(_vm.tableData[0].msg))]
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "20px", display: "flex" } },
        [
          _c("div", { staticClass: "colorCon" }, [
            _c("span", {
              staticClass: "colorClass colorClass1",
              staticStyle: { background: "#64B1FF" },
            }),
            _c("span", { staticClass: "colorTitle" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "receivablePayable.ThePriceBecomesLowerAfterRecalculation"
                  )
                ) +
                  "（" +
                  _vm._s(
                    (_vm.tableData[0] &&
                      _vm.tableData[0].resultTypeCountMap &&
                      _vm.tableData[0].resultTypeCountMap[3]) ||
                      0
                  ) +
                  "）"
              ),
            ]),
          ]),
          _c("div", { staticClass: "colorCon" }, [
            _c("span", {
              staticClass: "colorClass colorClass2",
              staticStyle: { background: "#FF3E3E" },
            }),
            _c("span", { staticClass: "colorTitle" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "receivablePayable.ThePriceBecomesHigherAfterRecalculation"
                  )
                ) +
                  "（" +
                  _vm._s(
                    (_vm.tableData[0] &&
                      _vm.tableData[0].resultTypeCountMap &&
                      _vm.tableData[0].resultTypeCountMap[2]) ||
                      0
                  ) +
                  "）"
              ),
            ]),
          ]),
          _c("div", { staticClass: "colorCon" }, [
            _c("span", {
              staticClass: "colorClass colorClass3",
              staticStyle: { background: "#999999" },
            }),
            _c("span", { staticClass: "colorTitle" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("receivablePayable.ThePriceAfterRecalculationIs0")
                ) +
                  "（" +
                  _vm._s(
                    (_vm.tableData[0] &&
                      _vm.tableData[0].resultTypeCountMap &&
                      _vm.tableData[0].resultTypeCountMap[1]) ||
                      0
                  ) +
                  "）"
              ),
            ]),
          ]),
          _c("div", { staticClass: "colorCon" }, [
            _c("span", {
              staticClass: "colorClass colorClass4",
              staticStyle: {
                background: "#FFFFFF",
                border: "1px solid #999999",
              },
            }),
            _c("span", { staticClass: "colorTitle" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "receivablePayable.ThePriceRemainsUnchangedAfterRecalculation"
                  )
                ) +
                  "（" +
                  _vm._s(
                    (_vm.tableData[0] &&
                      _vm.tableData[0].resultTypeCountMap &&
                      _vm.tableData[0].resultTypeCountMap[0]) ||
                      0
                  ) +
                  "）"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-table",
        {
          attrs: {
            "cell-class-name": _vm.myClass,
            data: _vm.tableData,
            border: "",
            height: "400",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              align: "center",
              width: "60px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.tableColumns, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                align: item.fixed,
                label: item.label,
                prop: item.prop,
                "show-overflow-tooltip": true,
                "min-width": item.width,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row[item.prop]))])]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.getCurrentTablePageData,
              "size-change": _vm.getSizeTablePageData,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.confirmReplacement(true)
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("receivablePayable.ConfirmTheReplacementPrice")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.confirmReplacement(false)
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("receivablePayable.CancelTheRecalculation")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }